// Brand tokens for LPA datasheets. Every component reads from this module — edit here to retheme.
export const theme = {
  navy: '#14315B',
  navyMid: '#2A4A78',
  ink: '#1C2430',
  inkDark: '#101418',
  muted: '#5A6B80',
  rule: '#9AA7B8',
  line: '#C9D3E0',
  tint: '#F0F3F8',
  tintLight: '#E4E9F1',
  green: '#76B82A',
  white: '#ffffff',
  font: "'Archivo','Helvetica Neue',Arial,sans-serif",
};

// Letter page, 96 dpi. Padding matches the approved layout (42 / 46 / 26).
export const PAGE = { width: 816, height: 1056, padding: '42px 46px 26px' };
